import React from 'react';
import { IconProps } from '.';

const SvgCheck = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M22.018 6.543 8.88 19.074l-6.936-7.662 1.112-1.006 5.902 6.52L20.982 5.457l1.036 1.086Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCheck;
